import { useParams } from "@tanstack/react-router";

export function useVendorId() {
  const params = useParams({ strict: false });
  return params.vendorId as string;
}
